/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import CloseIcon from "@mui/icons-material/Close";
import React from "react";

interface CustomBoxModalProps {
  className?: string;
  children: React.ReactNode;
  onClose?: () => void;
}

function CustomBoxModal({ children, onClose, className }: CustomBoxModalProps) {
  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center font-montserrat"
      role="dialog"
      aria-labelledby="modal-title"
      aria-describedby="modal-description"
    >
      <div
        className="absolute inset-0 bg-black/40 backdrop-blur-md backdrop-brightness-75"
        onClick={onClose}
      />

      <div
        className={`relative z-10 flex flex-col items-center bg-white rounded-3xl shadow-md p-4 ${className}`}
      >
        {children}
        {onClose && (
          <button
            type="button"
            onClick={onClose}
            className="absolute top-0 -right-10 p-2 bg-white h-8.25 w-8.25 rounded-full shadow-inner flex items-center justify-center"
            aria-label="Close"
          >
            <CloseIcon />
          </button>
        )}
      </div>
    </div>
  );
}

CustomBoxModal.defaultProps = {
  onClose: undefined,
  className: ""
};

export default CustomBoxModal;
